import { Injectable, signal, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as Rx from 'rxjs';

@Injectable()
export class IdleService {
	public readonly config = {
		TimeoutAfterSecconds: 600, //600
		WarningnForSeoncds: 120, //120
		ThrottleTime: 2000
	}; //idle for 10 minutes, show warning for 2 minutes, check activity every 2 seonds

	private destroyRef = inject(DestroyRef);

	// 1. Expose an Angular Signal for easy zoneless UI consumption
	private isUserIdle = signal<boolean>(false);
	public isIdle = this.isUserIdle.asReadonly();

	constructor() {
		this.startTracking();
	}

	private startTracking() {
		// 2. Track standard human activity indicators
		const activityEvents$ = Rx.merge(
			Rx.fromEvent(document, 'mousemove'),
			Rx.fromEvent(document, 'click'),
			Rx.fromEvent(document, 'keypress'),
			Rx.fromEvent(document, 'wheel'),
			Rx.fromEvent(document, 'touchstart')
		).pipe(
			// 3. Use throttleTime to drastically reduce the event stream
			Rx.throttleTime(this.config.ThrottleTime, undefined, { leading: true, trailing: true })
		);

		// 4. Reset the countdown timer every time an activity event fires
		activityEvents$.pipe(
			Rx.switchMap(() => {
				this.isUserIdle.set(false);
				return Rx.timer(this.config.TimeoutAfterSecconds * 1000).pipe(Rx.map(() => true));
			}),
			takeUntilDestroyed(this.destroyRef)
		).subscribe(() => {
			// 5. Timer expired: User is officially idle.
			this.isUserIdle.set(true);
		});
	}

	public reset() {
		this.isUserIdle.set(false);
	}
}
